import React, { Component } from 'react';

import Attachment from './Attachment';
import { FileUploader, InlineLoading } from 'carbon-components-react';

export default class AttachmentsWidget extends Component {

  maxFilesReached = () => {
    return this.props.maxFiles ?
      this.props.files?.length >= this.props.maxFiles : false;
  };

  handleOnChange = event => {
    if (!this.maxFilesReached())
      this.props.onFileAdded(event);
    else
      return;
  };

  render() {
    return (
      <div className={'attachments-widget ' + (this.maxFilesReached() ? 'disabled' : '')}>
        <div className="attachments">
          {this.props.files.map((file, i) => (
            <Attachment
              key={file.fileIdentifier}
              file={file}
              onDelete={this.props.onDelete}
              index={i}
            />
          ))}
        </div>

        {this.props.loading ?
          <div className='loading-message'>
            <InlineLoading /> <span>{this.props.loadingMessage}</span>
          </div>
          : null
        }

        <div className='attachments-max-limit-reached'>
        {/* RITM0954296-HOCCardTranslate */}
          {this.props.AttachmentmsgMaxAttachments || "Maximum number of attachments reached."} 
        </div>

        <FileUploader
          accept={['.jpeg', '.jpg', '.png', '.gif', '.bmp']}
          buttonKind="primary"
          buttonLabel={this.props.hoc4allAddPicture || "Add Picture"}// RITM0954296-HOCCardTranslate
          filenameStatus="edit"
          multiple={false}
          name="inputFile"
          onChange={this.props.onFileAdded}
        />

        <div className="attachments-message-container">
          {this.props.maxFiles ?
            <p className="attachments-message">
              • {this.props.AttachmentmsgMax || "Max"} {this.props.maxFiles} {this.props.Attachmentmsgallowed || "allowed"}
            </p>
            : null
          }
          {this.props.maxSize ?
            <p className="attachments-message">
              ••{this.props.msghoc4allFilelarger || "Files larger than"} {this.props.maxSize} {this.props.msghoc4allCompressed || "KB will be automatically compressed"}
            </p>
            : null
          }
        </div>

      </div>
    );
  }
}
